// PWA Entry point
import { Application } from "@hotwired/stimulus"
import PwaAppController from "./pwa/controllers/pwa_app_controller"
import PwaDashboardController from "./pwa/controllers/pwa_dashboard_controller"
import PwaAddTransactionController from "./pwa/controllers/pwa_add_transaction_controller"
import PwaStatsController from "./pwa/controllers/pwa_stats_controller"
import PwaBudgetsController from "./pwa/controllers/pwa_budgets_controller"
import PwaCategoriesController from "./pwa/controllers/pwa_categories_controller"
import PwaSettingsController from "./pwa/controllers/pwa_settings_controller"
import PwaAccountsController from "./pwa/controllers/pwa_accounts_controller"
import PwaToolsController from "./pwa/controllers/pwa_tools_controller"
import PwaSharedController from "./pwa/controllers/pwa_shared_controller"
import PwaGoalsController from "./pwa/controllers/pwa_goals_controller"
import PwaDebtsController from "./pwa/controllers/pwa_debts_controller"
import PwaRecurringController from "./pwa/controllers/pwa_recurring_controller"
import PwaAdvisorController from "./pwa/controllers/pwa_advisor_controller"
import PwaReferralsController from "./pwa/controllers/pwa_referrals_controller"
import PwaOnboardingController from "./pwa/controllers/pwa_onboarding_controller"
import PwaAchievementsController from "./pwa/controllers/pwa_achievements_controller"
import PwaImportController from "./pwa/controllers/pwa_import_controller"
import PwaForecastController from "./pwa/controllers/pwa_forecast_controller"

const application = Application.start()

application.register("pwa-app", PwaAppController)
application.register("pwa-dashboard", PwaDashboardController)
application.register("pwa-add-transaction", PwaAddTransactionController)
application.register("pwa-stats", PwaStatsController)
application.register("pwa-budgets", PwaBudgetsController)
application.register("pwa-categories", PwaCategoriesController)
application.register("pwa-settings", PwaSettingsController)
application.register("pwa-accounts", PwaAccountsController)
application.register("pwa-tools", PwaToolsController)
application.register("pwa-shared", PwaSharedController)
application.register("pwa-goals", PwaGoalsController)
application.register("pwa-debts", PwaDebtsController)
application.register("pwa-recurring", PwaRecurringController)
application.register("pwa-advisor", PwaAdvisorController)
application.register("pwa-referrals", PwaReferralsController)
application.register("pwa-onboarding", PwaOnboardingController)
application.register("pwa-achievements", PwaAchievementsController)
application.register("pwa-import", PwaImportController)
application.register("pwa-forecast", PwaForecastController)
